import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";

import {App} from './App';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import {StrictMode} from "react";

Bugsnag.start({
    apiKey: 'd6336bc3fc9f8a6d8aad5c291487ce5a',
    plugins: [new BugsnagPluginReact()]
})

import './index.css';

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

ReactDOM.render(
    <StrictMode>
        <ErrorBoundary>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </ErrorBoundary>
    </StrictMode>
    , document.getElementById('root')
);
